module.exports = __webpack_public_path__ + "img/365.b6052364.jpg";